import { CATALOGS, useRegistry, type TagFilterValue } from "../registry";
import type { RegistryCatalog } from "../types";

/** Catalog + key picker for filtering by a registry tag. Families match their members. */
export default function TagFilter({
  value,
  onChange,
  idPrefix,
}: {
  value: TagFilterValue;
  onChange: (next: TagFilterValue) => void;
  idPrefix: string;
}) {
  const { data: registry, isLoading } = useRegistry();
  const entries = registry?.catalogs[value.catalog] ?? [];

  return (
    <>
      <label className="form-control" htmlFor={`${idPrefix}-tag-catalog`}>
        <span className="label-text text-xs">Tag type</span>
        <select
          id={`${idPrefix}-tag-catalog`}
          className="select select-bordered select-sm"
          value={value.catalog}
          onChange={(e) => onChange({ catalog: e.target.value as RegistryCatalog, key: "" })}
        >
          {CATALOGS.map((c) => (
            <option key={c.catalog} value={c.catalog}>
              {c.label}
            </option>
          ))}
        </select>
      </label>
      <label className="form-control" htmlFor={`${idPrefix}-tag-key`}>
        <span className="label-text text-xs">Tag</span>
        <select
          id={`${idPrefix}-tag-key`}
          className="select select-bordered select-sm max-w-56"
          value={value.key}
          disabled={isLoading}
          onChange={(e) => onChange({ ...value, key: e.target.value })}
        >
          <option value="">Any</option>
          {entries.map((e) => (
            <option key={e.key} value={e.key}>
              {e.parent ? "  " : ""}
              {e.name}
              {e.is_family ? " (all)" : ""}
            </option>
          ))}
        </select>
      </label>
    </>
  );
}
